import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getFormValues } from "redux-form";
import { fetchCategoryBySlug } from "../../../../redux/actions/category";
import { getPreviousNextStep } from "./PathHelpers";

export const useChangeServiceHook = ({ steps, step, categorySlug, change }) => {
  const { previousStep, nextStep } = step ? getPreviousNextStep(steps, step.id) : {};
  const { t } = useTranslation("changeService");
  const dispatch = useDispatch();
  const category = useSelector(({ category }) =>
    category.categories.find((category) => category.slug === categorySlug)
  );

  useEffect(() => {
    if (!category && categorySlug) {
      dispatch(fetchCategoryBySlug(categorySlug));
    }
  }, [categorySlug, dispatch, category]);

  useEffect(() => {
    if (category) {
      change("categoryId", category.id);
    }
  }, [category, change]);
  const currentValues = useSelector((state) => getFormValues("ChangeService")(state));
  const categoryName = categorySlug === "gas" ? "Gas" : "Strom";
  const isCategoryStrom = categoryName === "Strom";

  return { previousStep, nextStep, t, currentValues, categoryName, isCategoryStrom, category };
};
